import { Button } from "@components/Button";
import { Notification } from "@components/Notification/Notification";

export interface IBillErrorNotification {
  formId: string;
  description: string;
  buttonText: string;
}

export const BillErrorsNotification: React.FC<IBillErrorNotification> = ({
  description,
  buttonText,
  formId = "InvalidBillDetailForm",
}) => {
  const scrollToFirstInvalidField = () => {
    const yOffset = -250;
    const element = document.getElementById(formId);
    if (element) {
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Notification
      description={description}
      color="red"
      button={
        <Button variant="link" onClick={scrollToFirstInvalidField}>
          {buttonText}
        </Button>
      }
    />
  );
};
